export default __webpack_public_path__ + "media/dbc697decfcb867aaef9b0a4fd3a77ae49255770f63f666b6224de5f2bcdc224.svg";